<form [formGroup]="vendaForm" class="forms">
  <div class="row">
    <div class="row info-container white-box">
      <h2>Vendas último trimestre</h2>
      <div class="form-group">
        <span class="icon calendario-cash"></span>
        <div class="inputs">
          <label for="valorAUmMes">Há 1 mês</label>
          <input
            class="form-control"
            type="text"
            placeholder="R$ 0.000,00"
            name="valorAUmMes"
            formControlName="valorAUmMes"
            [maxLength]="15"
            [minLength]="1"
            appOnlyDigitsLengthValidator
            appShowErrorMessages
            mask-money
            inputmode="numeric"
            [prefix]="'R$'"
            appOnlyNumberRestrictive>
        </div>
      </div>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="valorADoisMeses">Há 2 meses</label>
          <input
            class="form-control"
            type="text"
            placeholder="R$ 0.000,00"
            name="valorADoisMeses"
            formControlName="valorADoisMeses"
            [maxLength]="15"
            [minLength]="1"
            appOnlyDigitsLengthValidator
            appShowErrorMessages
            mask-money
            inputmode="numeric"
            [prefix]="'R$'"
            appOnlyNumberRestrictive>
        </div>
      </div>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="valorATresMeses">Há 3 meses</label>
          <input
            class="form-control"
            type="text"
            placeholder="R$ 0.000,00"
            name="valorATresMeses"
            formControlName="valorATresMeses"
            [maxLength]="15"
            [minLength]="1"
            appOnlyDigitsLengthValidator
            appShowErrorMessages
            mask-money
            inputmode="numeric"
            [prefix]="'R$'"
            appOnlyNumberRestrictive>
        </div>
      </div>
      <div class="form-group">
        <span class="icon vazio"></span>
        <div class="inputs">
          <label for="faefPrazoCliente">Prazo concedido aos clientes</label>
          <select
                class="form-control"
                appShowErrorMessages
                formControlName="faefPrazoCliente">
            <option value="" selected hidden>Selecione...</option>
            <option value="1">À VISTA</option>
            <option value="2">ATÉ 15 DIAS</option>
            <option value="3">ATÉ 30 DIAS</option>
            <option value="4">ATÉ 60 DIAS</option>
            <option value="5">ATÉ 90 DIAS</option>
            <option value="6">MAIS DE 90 DIAS</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</form>

<form [formGroup]="mercadoriaForm" class="forms">
  <div class="row">
    <div class="row info-container white-box">
      <h2>Margem Bruta</h2>
      <div class="form-group">
        <span class="icon money-bill"></span>
        <div class="inputs">
          <label for="nomeMercadoria">MERCADORIAS</label>

          <app-mercadoria-faef *ngFor="let mercadoria of mercadorias; index as i" [mercadoria]="mercadoria" (edit)="onMercadoriaEdit(i)" (remove)="onMercadoriaRemove(i)"></app-mercadoria-faef>

          <input
            class="form-control"
            type="text"
            placeholder="Nome da mercadoria"
            id="nomeMercadoria"
            formControlName="nomeMercadoria"
            maxlength="100"
            minlength="3"
            appShowErrorMessages>
          <input
            class="form-control"
            type="text"
            placeholder="Quantidade vendida"
            formControlName="quantidadeVendida"
            maxlength="6"
            minlength="1"
            inputmode="numeric"
            appShowErrorMessages
            appOnlyNumberRestrictive>
          <input
            class="form-control"
            type="text"
            placeholder="Quantidade em estoque"
            formControlName="quantidadeEstoque"
            maxlength="6"
            minlength="1"
            inputmode="numeric"
            appShowErrorMessages
            appOnlyNumberRestrictive>
          <input
            class="form-control"
            type="text"
            placeholder="Custo unitário de compra R$"
            formControlName="precoUnitarioCompra"
            [maxLength]="15"
            [minLength]="1"
            appOnlyDigitsLengthValidator
            appShowErrorMessages
            mask-money
            inputmode="numeric"
            [prefix]="'R$'"
            appOnlyNumberRestrictive>
          <input
            class="form-control"
            type="text"
            placeholder="Preço unitário de venda R$"
            formControlName="precoUnitarioVenda"
            [maxLength]="15"
            [minLength]="1"
            appOnlyDigitsLengthValidator
            appShowErrorMessages
            mask-money
            inputmode="numeric"
            [prefix]="'R$'"
            appOnlyNumberRestrictive>

          <div class="mt15 centered">
            <button class="bt-go btn btn-border-orange"
                *ngIf="editing < 0"
                (click)="addMercadoria()"
                [disabled]="mercadoriaForm.invalid">
                <em class="fa fa-plus mrBt"></em>
                Adicionar Mercadoria
              </button>

              <button class="bt-go btn btn-border"
                *ngIf="editing >= 0"
                (click)="cancelar()">
                Cancelar
              </button>

              <button class="bt-go btn btn-border-orange"
                *ngIf="editing >= 0"
                (click)="addMercadoria()"
                [disabled]="mercadoriaForm.invalid">
                Salvar Mercadoria
              </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<app-botao-navegacao
(previous)="onClickPrevious()"
(next)="onClickNext()"
[previousShow]="true"
[nextShow]="true"
[nextEnabled]="vendaForm.valid && mercadorias.length > 0">
</app-botao-navegacao>
